import React from 'react';
import PropTypes from 'prop-types';
import gameTileLayout from '../constants/gameTileLayoutConstants';

function NativeAd({ translate }) {
  return (
    <div className='game-card-native-ad'>
      <span className='font-footer native-ad-label'>{translate(gameTileLayout.nativeAdLabel)}</span>
    </div>
  );
}

NativeAd.propTypes = {
  translate: PropTypes.func.isRequired
};

export default NativeAd;
